import { render, staticRenderFns } from "./FundraiserStats.vue?vue&type=template&id=0e10ef32"
import script from "./FundraiserStats.vue?vue&type=script&lang=js"
export * from "./FundraiserStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports